// Legacy demon behavior — simulation stays in demon.ts; this is a registry stub.

import { registerBehavior } from './registry';
import { MoveEntities, DrawEntities } from '../demon';

registerBehavior({
  id: 'meritous:legacy-demon',
  onTick() {
    // Legacy enemies are ticked via MoveEntities() in dungeon-update.
  },
});

/** Called once per frame for legacy stack (delegates to demon.c port). */
export function tickLegacyDemonStack(): void {
  MoveEntities();
}

export function drawLegacyDemonStack(): void {
  DrawEntities();
}
